<script>
    import { GetMonsterSkillName, GetMonsterSkillAttribute, GetMonsterMasterSkillName, GetMonsterMasterSkillDetail } from '../../../script/_monster'
    
    export let Monster, Section, Skills, DataCheck
</script>

<div class='skills'>zzzz
    {#if Skills.length > 0}
        {#each Skills as skill, i}
            <div class="skill">
                <div class="left">
                    <img
                        src="../img/monsters/{Monster}/{Section}_{(skill.num)}.png"
                        alt="{Monster}"
                    >
                </div>

                <div class="right">
                    <div class="row">
                        <div class="name">
                            <img
                                src="../img/monsters/{Monster}/{Section}_{(skill.num)}.png"
                                alt="{Monster}"
                            >
                            {#if DataCheck == 0}
                                {GetMonsterSkillName(Monster, Section, (skill.num-1))}
                            {:else}
                                {skill.name}
                            {/if}
                        </div>
                    </div>

                    <div class="row">
                        <div class="tag">특성</div>

                        <ul>
                            {#each skill.attribute as attribute}
                                <li>
                                    {#if DataCheck == 0}
                                        {GetMonsterSkillAttribute(Monster, Section, (skill.num-1), attribute)}
                                    {:else}
                                        {attribute.detail}
                                    {/if}
                                </li>
                            {/each}

                            {#if skill.attribute.length == 0}
                                미선택
                            {/if}
                        </ul>
                    </div>

                    {#if Section == 0}
                        <div class="row">
                            <div class="tag">마스터</div>

                            <div class="master">
                                {#if
                                    (skill.master >= 0 && DataCheck == 0) ||
                                    (skill.master.num >= 0 && DataCheck == 1)
                                }
                                    {#if DataCheck == 0}
                                        {GetMonsterMasterSkillName(Monster, Section, (skill.num-1), skill.master)} :
                                        {GetMonsterMasterSkillDetail(Monster, Section, (skill.num-1), skill.master)}
                                    {:else}
                                        {skill.master.name} : {skill.master.detail}
                                    {/if}
                                {:else}
                                    미선택
                                {/if}
                            </div>
                        </div>
                    {/if}

                </div>
            </div>

            {#if (Skills.length-1) > i }
                <hr/>
            {/if}
        {/each}
    {:else}
        추천 스킬이 없습니다.
    {/if}
</div>

<style lang="scss">
    .skills {
        width: calc(100%);
        height: fit-content;

        .skill {
            width: calc(100%);
            height: fit-content;
            margin-bottom: 20px;

            .left {
                width: calc(25% - 18px);
                margin-right: 18px;
                display: inline-block;
                vertical-align: top;

                img { width: 100%; }
            }

            .right {
                width: calc(75%);
                height: fit-content;
                display: inline-block;
                vertical-align: top;

                .row {
                    width: calc(100%);
                    height: fit-content;
                    font-size: 15px;

                    .name {
                        font-size: 20px; font-weight: 700;
                        img { display: none; }
                    }
                    .tag { margin-top: 15px; font-weight: 700; }
                    ul {
                        width: fit-content;
                        height: fit-content;
                        margin: 0;
                        padding: 0;

                        li {
                            list-style: none;
                            /* 단어 단위로 자르기 */
                            word-break: keep-all;
                        }
                    }
                    .master {
                        word-break: keep-all;
                    }
                }
            }
        }

        hr {
            border: 1px solid $cl3;
            margin-bottom: 20px;
        }

        @include mobile {
            .skill {
                margin-bottom: 10px;
                .left { display: none; }
                .right {
                    width: calc(100%);

                    .row {
                        font-size: 12px;
                        .name {
                            font-size: 16px;
                            img { width: 12px; display: inline-block; }
                        }
                        .tag { margin-top: 10px; }
                    }
                }
            }
            hr { margin-bottom: 10px; }
        }
    }
</style>